import { ESignatureInput, type ESignatureValue } from "ui2";

export const isSignatureReady = (value: ESignatureValue): boolean =>
  Boolean(value.data && value.agreedToDisclosure);

export const SignatureField = ({
  value,
  onChange,
}: {
  value: ESignatureValue;
  onChange: (value: ESignatureValue) => void;
}): React.JSX.Element => (
  <ESignatureInput
    label="Sign to confirm you attended"
    description="Use your finger. This is your record for this meeting."
    value={value}
    onChange={onChange}
  />
);
